import { useDomainFromUrl } from '@/app/_common/domain/use-domain-from-url'
import { useSplitViewQueryState } from '@/app/_common/split-view/split-view-context'
import { useMemo } from 'react'

export function useServiceOAuthRedirectUri({ serviceId }: { serviceId?: string }) {
  const { domainId } = useDomainFromUrl()
  const splitViewQueryState = useSplitViewQueryState()

  return useMemo(() => {
    const params = new URLSearchParams()
    params.set('domain', domainId)
    if (splitViewQueryState) {
      params.set('view', splitViewQueryState)
    }
    if (serviceId) {
      params.set('serviceId', serviceId)
    }
    return new URL(
      window.location.origin + window.location.pathname + '?' + params.toString(),
    ).toString()
  }, [domainId, splitViewQueryState])
}
